import { StateEnum } from "./StateEnum";

export class BaseModel {
    public id = 0;
    public state: StateEnum = StateEnum.Unchanged;
  }